import React from 'react';
import { ITextButtonProps, TextButton } from '../../../../ui';
import signOutIcon from '../../../../../assets/logout.svg?reference';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';

export interface ISignOutButtonProps extends ITextButtonProps {}

export const SignOutButton = (props: ISignOutButtonProps) => {
	const { t } = useTranslation();

	return (
		<>
			<TextButton {...props}>{t('sign_out_link')}</TextButton>
			<img src={signOutIcon} alt={t('sign_in_account_label')} />
		</>
	);
};

export interface ISignOutProps extends Omit<ISignOutButtonProps, 'onClick'> {
	redirectUrl?: string;
}

export const SignOut = ({ redirectUrl, ...rest }: ISignOutProps) => (
	<SignOutButton {...rest} />
);
